// extracted by mini-css-extract-plugin
module.exports = {"modalBg":"modal_modalBg__fv73x"};